import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see {@link https://jira.vk.team/browse/CLOUDWEB-19983} Редактирование копии аттачей для b2b
 */
export const attachCopyEditB2B = getFeature('attach-copy-edit-b2b') as boolean | undefined;
